module.exports = __webpack_public_path__ + "static/media/expiiFlyer.7c66efeb.png";